export default template;
function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (list) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E\u003Cdiv class=\"form\"\u003E\u003Cdiv\u003E\u003Clabel\u003EOrder #\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Cinput class=\"form-control\" name=\"orderNumber\" type=\"number\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"find\"\u003ESearch\u003C\u002Fbutton\u003E\u003Cdiv class=\"orders\"\u003E";
if (list) {
pug_html = pug_html + "\u003Chr\u003E\u003Cdiv\u003E" + (null == (pug_interp = list) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "list" in locals_for_with ?
        locals_for_with.list :
        typeof list !== 'undefined' ? list : undefined));
    ;;return pug_html;}